import { createReducer, on } from "@ngrx/store";
import { loadResetPasswordByIdAct, loadResetPasswordByTokenAct, saveResetPasswordAct, saveSuccessResetPasswordaAct, setViolationsResetPasswordAct, showMsgSuccessAct, updateResetPasswordAct, updateSuccessResetPasswordAct } from "./reset-password.actions";
import { ResetPassword } from "../../models/reset-password";


const resetPassword: ResetPassword = new ResetPassword();
export const resetPasswordReducer = createReducer({
    resetPassword,
    violations: {},
    loading: false
},
    on(loadResetPasswordByIdAct, (state, { resetPassword }) => ({
        resetPassword: resetPassword,
        violations: {},
        loading: false
    })),

    on(loadResetPasswordByTokenAct, (state, { resetPassword }) => ({
        resetPassword: resetPassword,
        violations: {},
        loading: false
    })),

    on(saveSuccessResetPasswordaAct, (state, { resetPasswordNew }) => ({
        resetPassword: { ...resetPasswordNew },
        violations: {},
        loading: state.loading
    })),

    on(updateSuccessResetPasswordAct, (state, { resetPasswordUpdated }) => ({
        resetPassword: { ...resetPasswordUpdated },
        violations: {},
        loading: state.loading
    })),

    on(setViolationsResetPasswordAct, (state, { resetPasswordForm, violations }) => ({
        resetPassword: state.resetPassword,
        violations: { ...violations },
        loading: state.loading
    })),
    
    on(showMsgSuccessAct, (state, { msg }) => ({
        resetPassword: state.resetPassword,
        violations: { },
        loading: false
    })),
    
    on(saveResetPasswordAct, (state, { resetPasswordNew }) => ({
        resetPassword: state.resetPassword,
        violations: { },
        loading: true
    })),
    
    on(updateResetPasswordAct, (state, { resetPasswordUpdated }) => ({
        resetPassword: state.resetPassword,
        violations: { },
        loading: true
    })),
    
    on(updateSuccessResetPasswordAct, (state, { resetPasswordUpdated }) => ({
        resetPassword: state.resetPassword,
        violations: { },
        loading: false
    }))

)